<template>
  <div class="card">
    <div v-if="errorText !== ''" class="error-box">
      <p class="error">{{ errorText }}</p>
    </div>
    <h2 class="title">Registreren</h2>
    <form @submit.prevent="registerAccount">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <h3 for="registerFirstName">Voornaam</h3>
            <input id="registerFirstName" type="text" class="form-control" v-model="firstName">
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <h3 for="registerLastName">Naam</h3>
            <input id="registerLastName" type="text" class="form-control" v-model="lastName">
          </div>
        </div>
      </div>
      <div class="form-group">
        <h3 for="registerUsername">E-mailadres</h3>
        <input id="registerUsername" type="email" class="form-control" v-model="email" autocomplete="username">
      </div>

      <ZipSchoolForm :closeOnSelected="false" :selected-school="selectedSchool"
                     @selectSchool="selectSchool"></ZipSchoolForm>

      <div class="form-group">
        <h3 for="registerPassword">Wachtwoord</h3>
        <input id="registerPassword" type="password" class="form-control" v-model="password"
               autocomplete="new-password">
      </div>

      <div class="form-group">
        <h3 for="registerPasswordConfirm">Wachtwoord bevestigen</h3>
        <input id="registerPasswordConfirm" type="password" class="form-control" v-model="passwordConfirm"
               autocomplete="new-password">
      </div>

      <div class="form-group">
        <v-button :enabled="isValid" :buttonText="'Registreren'" type="submit"></v-button>
      </div>
    </form>
  </div>

</template>

<script>
import { AuthApi } from 'sandpiper_api'
import VButton from "@/components/UI/VButton";
import ZipSchoolForm from "@/components/ZipSchoolForm"

export default {
  name: "Register",
  components: { VButton, ZipSchoolForm },
  inject: [ "doApiRequest" ],
  data()
  {
    return {
      firstName: '',
      lastName: '',
      zipcode: '',
      email: '',
      password: '',
      passwordConfirm: '',
      selectedSchool: null,
      errorText: "",
    }
  },
  computed: {
    isValid()
    {
      if (this.firstName === "" || this.firstName === null)
      {
        return false;
      }

      if (this.lastName === "" || this.lastName === null)
      {
        return false;
      }

      if (this.email === "" || this.email === null)
      {
        return false;
      }

      if (this.password === "" || this.password === null)
      {
        return false;
      }

      if (this.password !== this.passwordConfirm)
      {

        return false;
      }

      if (this.selectedSchool === null)
      {
        return false;
      }

      return true;
    },
  },
  watch: {
    password()
    {
      if (this.password !== this.passwordConfirm)
      {
        this.errorText = "De wachtwoorden komen niet overeen";
      }
      else
      {
        this.errorText = "";
      }
    },
    passwordConfirm()
    {
      if (this.password !== this.passwordConfirm)
      {
        this.errorText = "De wachtwoorden komen niet overeen";
      }
      else
      {
        this.errorText = "";
      }
    }
  },
  methods: {
    selectSchool(school)
    {
      this.selectedSchool = school;
    },
    async registerAccount()
    {
      try
      {
        this.fetchingSchools = true;

        this.schools = [];

        await this.doApiRequest(() => new AuthApi().authSignup({
          email: this.email,
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
          schoolId: this.selectedSchool.id
        }));

        await this.$router.push({ name: "register-confirmed" });
      }
      catch (e)
      {
        // TODO - handle error
        if (e.body.error === "USERSIGNUP_EMAIL_ALREADY_ASSOCIATED")
        {
          this.errorText = "Dit e-mailadres is al in gebruik voor een ander account.";
        }
        else if (e.body.error === "INTERNAL_SERVER_ERROR")
        {
          this.errorText = "Er ging iets mis bij het aanmaken van dit account.";
        }
      }
      finally
      {
        this.fetchingSchools = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  padding: 25px;
  margin-top: 25px;

  .title {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .subtitle {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }

  .text-button {
    display: block;
    text-align: center;
    text-decoration: underline;
    font-weight: bold;
    margin-bottom: 1rem;
  }

  input[type="text"], input[type="password"] {
    box-shadow: $default-shadow;
  }

  .error-box {
    border: 2px solid darkred;
    padding: 5px;
    margin-bottom: 15px;

    .error {
      color: darkred;
      margin-bottom: 0px;
      font-weight: bold;
    }
  }
}
</style>